const translations: Record<string, string> = {
  // Nav
  'nav.home': 'Trang chủ',
  'nav.about': 'Giới thiệu',
  'nav.services': 'Dịch vụ',
  'nav.partners': 'Đối tác',
  'nav.tradeData': 'Dữ liệu TM',
  'nav.gallery': 'Thư viện',
  'nav.getInTouch': 'Liên hệ',

  // Hero
  'hero.eyebrow': 'Tư vấn xuất nhập khẩu thương hiệu, phân phối & marketing',
  'hero.headline1': 'HÀN QUỐC · VIỆT NAM',
  'hero.headline2': 'Brand Gateway\u00a0',
  'hero.headline3': 'Monaru',
  'hero.desc': 'Chúng tôi trực tiếp kích hoạt mạng lưới địa phương tại Hàn Quốc và Việt Nam để xử lý các chứng nhận phức tạp và ngay lập tức thực hiện việc gia nhập các kênh phân phối lớn. Chúng tôi giảm thiểu thử nghiệm và sai sót khi thâm nhập thị trường và chỉ cam kết những kết quả chắc chắn.',
  'hero.cta1': 'Xem dịch vụ',
  'hero.cta2': 'Bắt đầu hợp tác',
  'hero.scroll': 'Cuộn',
  'hero.stat.tradeVolume': 'Khối lượng TM',
  'hero.stat.activePartners': 'Đối tác',
  'hero.stat.yearsExp': 'Năm kinh nghiệm',
  'hero.stat.nationsServed': 'Quốc gia',

  // About Preview
  'about.eyebrow': 'Giới thiệu',
  'about.established': 'Since 2026',
  'about.heading1': 'Đối tác mở rộng thương hiệu toàn cầu',
  'about.heading2': 'Chúng tôi tạo ra',
  'about.desc1': 'Sự lo lắng về thị trường xa lạ sẽ chuyển thành sự tự tin. MONARU trực tiếp kích hoạt mạng lưới địa phương tại Hàn Quốc và Việt Nam, là đối tác giải pháp toàn diện chịu trách nhiệm cho toàn bộ quá trình — từ Seeding (gieo hạt) đến Distribution (phân phối) cho thương hiệu của bạn. Dựa trên cảm nhận thị trường địa phương sâu sắc và quy trình chứng nhận chuyên nghiệp, chúng tôi dẫn dắt doanh nghiệp của bạn đến trung tâm thị trường một cách an toàn và nhanh chóng.',
  'about.pillar1.title': 'Chứng nhận & Hải quan',
  'about.pillar1.desc': 'Xử lý một cửa MFDS, CR và tất cả các phê duyệt quy định phức tạp tại cả hai thị trường.',
  'about.pillar2.title': 'Vào kênh phân phối',
  'about.pillar2.desc': 'Kết nối trực tiếp vào siêu thị lớn, cửa hàng tiện lợi và các nền tảng trực tuyến lớn.',
  'about.pillar3.title': 'Bản địa hóa thương hiệu',
  'about.pillar3.desc': 'Chiến lược marketing phù hợp với xu hướng người tiêu dùng từng quốc gia để định vị thương hiệu.',
  'about.stat1.value': '14+',
  'about.stat1.label': 'Năm kinh nghiệm',
  'about.stat2.value': '120+',
  'about.stat2.label': 'Đối tác đang hoạt động',
  'about.stat3.value': '2 Hub',
  'about.stat3.label': 'Mạng lưới trực tiếp',
  'about.bridge': 'Kết nối trực tiếp',
  'about.learnStory': 'Tìm hiểu thêm về chúng tôi',

  // Services Preview
  'services.eyebrow': 'Dịch vụ',
  'services.heading1': 'Giải pháp thương mại',
  'services.heading2': 'toàn diện & dịch vụ',
  'services.viewAll': 'Xem tất cả dịch vụ',
  'services.explore': 'Khám phá dịch vụ',

  // Trade Data
  'tradeData.eyebrow': 'Thông tin thời gian thực',
  'tradeData.heading1': 'Luồng thương mại',
  'tradeData.heading2': 'Phân tích',
  'tradeData.desc1': 'Theo dõi luồng thương mại song phương giữa Hàn Quốc và Việt Nam với nền tảng dữ liệu toàn diện. Đưa ra quyết định sáng suốt với số liệu thời gian thực, phân tích xu hướng và phân tích theo lĩnh vực.',
  'tradeData.desc2': 'Cập nhật hàng tháng với dữ liệu từ KITA, VCCI và cơ quan hải quan của cả hai quốc gia.',
  'tradeData.viewDashboard': 'Xem bảng điều khiển đầy đủ',
  'tradeData.vsPriorYear': 'so với năm trước',

  // Partners
  'partners.trustedBy': 'Được tin tưởng bởi',
  'partners.heading': 'Đối tác chiến lược',
  'partners.sub': 'Cùng nhau xây dựng thành công',
  'partners.viewAll': 'Xem tất cả đối tác',

  // CTA
  'cta.eyebrow': 'Sẵn sàng bắt đầu?',
  'cta.heading': 'Cửa ngõ thương mại Hàn Quốc-Việt Nam',
  'cta.desc': 'Kết nối với chuyên gia thương mại và khám phá cách MONARU có thể thúc đẩy doanh nghiệp của bạn qua một trong những hành lang thương mại phát triển nhanh nhất châu Á.',
  'cta.primary': 'Nhận tư vấn miễn phí',
  'cta.secondary': 'Khám phá dịch vụ',

  // Footer
  'footer.tagline': 'Đưa tâm huyết thương hiệu vào cuộc sống hằng ngày của người tiêu dùng toàn cầu.',
  'footer.services': 'Dịch vụ',
  'footer.company': 'Công ty',
  'footer.copyright': '© 2025 MONARU. Bảo lưu mọi quyền.',
  'footer.privacy': 'Chính sách bảo mật',
  'footer.terms': 'Điều khoản dịch vụ',
  'footer.cookies': 'Chính sách cookie',
  'footer.svc1': 'Chứng nhận & Hải quan',
  'footer.svc2': 'Vào kênh phân phối',
  'footer.svc3': 'Bản địa hóa thương hiệu',
  'footer.svc4': 'Tư vấn thâm nhập thị trường',
  'footer.svc5': 'Tìm kiếm & Phát triển thương hiệu',
  'footer.svc6': 'Quản lý logistics & giao hàng',
  'footer.aboutUs': 'Về chúng tôi',
  'footer.ourPartners': 'Đối tác',
  'footer.gallery': 'Thư viện',
  'footer.tradeData': 'Dữ liệu thương mại',
  'footer.contactUs': 'Liên hệ',
  'footer.ftaGuide': 'Hướng dẫn FTA Hàn-Việt',
  'footer.tradeStats': 'Thống kê thương mại',
  'footer.shippingSchedules': 'Lịch vận chuyển',
  'footer.regulatoryUpdates': 'Cập nhật quy định',

  // About Page
  'aboutPage.eyebrow': 'Về chúng tôi',
  'aboutPage.heading2': 'MONARU',
  'aboutPage.heroDesc': 'Bến đò của tất cả mọi người. Trung tâm kết nối hai nền kinh tế năng động nhất châu Á.',
  'aboutPage.story.eyebrow': 'Câu chuyện của chúng tôi',
  'aboutPage.story.heading': 'Từ Seoul đến Sài Gòn — Một thập kỷ thương mại',
  'aboutPage.story.p1': 'Năm 2010, một nhóm nhỏ chuyên gia thương mại Hàn Quốc và Việt Nam nhận ra một khoảng trống quan trọng: dù tiềm năng to lớn của thương mại Hàn-Việt, các doanh nghiệp hai phía thiếu một đối tác song ngữ đáng tin cậy thực sự hiểu cả hai thị trường.',
  'aboutPage.story.p2': 'KV Trade Alliance ra đời từ nhận thức đó. Bắt đầu với 12 chuyên gia tại văn phòng Seoul, chúng tôi xây dựng uy tín từng lô hàng, từng giao dịch, từng quan hệ đối tác.',
  'aboutPage.story.p3': 'Ngày nay, với hơn 85 chuyên gia tại cả hai thủ đô, chúng tôi đã trở thành đại lý thương mại song phương đáng tin cậy nhất khu vực — tạo điều kiện cho hơn 4,2 tỷ USD thương mại hàng năm và phục vụ cả khách hàng Fortune 500 lẫn các doanh nghiệp vừa và nhỏ năng động.',
  'aboutPage.story.cta': 'Hợp tác với chúng tôi',
  'aboutPage.values.eyebrow': 'Nền tảng của chúng tôi',
  'aboutPage.values.heading': 'Sứ mệnh & Giá trị',
  'aboutPage.values.sub': 'Động lực đằng sau mọi quyết định',
  'aboutPage.milestones.eyebrow': 'Hành trình của chúng tôi',
  'aboutPage.milestones.heading': 'Các cột mốc quan trọng',
  'aboutPage.value.partnership.title': 'Đối tác là trên hết',
  'aboutPage.value.partnership.desc': 'Chúng tôi xây dựng mối quan hệ lâu dài, không chỉ giao dịch. Sự phát triển của bạn là thành công của chúng tôi.',
  'aboutPage.value.integrity.title': 'Luôn chính trực',
  'aboutPage.value.integrity.desc': 'Giao dịch minh bạch, tư vấn trung thực và thực hành đạo đức trong mọi thị trường chúng tôi phục vụ.',
  'aboutPage.value.innovation.title': 'Đổi mới sáng tạo',
  'aboutPage.value.innovation.desc': 'Tận dụng công nghệ và dữ liệu để cung cấp các giải pháp thương mại thông minh hơn, nhanh hơn, hiệu quả hơn.',
  'aboutPage.value.local.title': 'Chuyên môn địa phương',
  'aboutPage.value.local.desc': 'Kiến thức sâu rộng về văn hóa và quy định tại cả Hàn Quốc và Việt Nam — lợi thế cạnh tranh của bạn.',
  'aboutPage.ms.2010.title': 'Thành lập tại Seoul',
  'aboutPage.ms.2010.desc': 'KV Trade Alliance thành lập với đội ngũ 12 chuyên gia thương mại tập trung vào thương mại song phương Hàn-Việt.',
  'aboutPage.ms.2013.title': 'Văn phòng TP. Hồ Chí Minh',
  'aboutPage.ms.2013.desc': 'Mở văn phòng Việt Nam đầu tiên, trở thành đại lý thương mại Hàn Quốc đầu tiên có hiện diện thường trực tại TP.HCM.',
  'aboutPage.ms.2016.title': 'Cột mốc 1 tỷ USD',
  'aboutPage.ms.2016.desc': 'Vượt mốc 1 tỷ USD thương mại song phương, phục vụ hơn 200 khách hàng doanh nghiệp tại cả hai quốc gia.',
  'aboutPage.ms.2019.title': 'Chứng nhận chuyên gia FTA',
  'aboutPage.ms.2019.desc': 'Trở thành công ty chuyên gia FTA Hàn-Việt được công nhận chính thức, giúp 90% khách hàng tiết kiệm thuế ưu đãi.',
  'aboutPage.ms.2022.title': 'Nền tảng thương mại số',
  'aboutPage.ms.2022.desc': 'Ra mắt nền tảng phân tích thương mại và theo dõi hàng hóa độc quyền, thay đổi cách quản lý logistics xuyên biên giới.',
  'aboutPage.ms.2024.title': 'Năm kỷ lục 4,2 tỷ USD',
  'aboutPage.ms.2024.desc': 'Đạt kỷ lục 4,2 tỷ USD khối lượng thương mại với hơn 1.240 đối tác doanh nghiệp tại 24 quốc gia.',

  // Services Page
  'servicesPage.eyebrow': 'Dịch vụ MONARU',
  'servicesPage.heading1': 'Gói thâm nhập thị trường thương hiệu',
  'servicesPage.heading2': 'Tất cả cùng nhau',
  'servicesPage.heroDesc': 'Từ chứng nhận đến phân phối và bản địa hóa thương hiệu — giảm thiểu thử nghiệm và sai sót khi thâm nhập thị trường Hàn Quốc và Việt Nam, chỉ tập trung vào kết quả chắc chắn. MONARU đồng hành cùng bạn trong toàn bộ quá trình.',
  'servicesPage.cta.heading': 'Sẵn sàng bắt đầu thâm nhập thị trường thương hiệu?',
  'servicesPage.cta.desc': 'Bắt đầu tư vấn miễn phí với chuyên gia ngay bây giờ và nhận chiến lược thâm nhập tùy chỉnh phù hợp với thương hiệu của bạn.',
  'servicesPage.cta.btn': 'Đăng ký tư vấn miễn phí',
  'servicesPage.enquireNow': 'Hỏi ngay',

  // Contact Page
  'contactPage.eyebrow': 'Liên hệ',
  'contactPage.heading1': 'Chúng tôi có thể giúp gì cho bạn?',
  'contactPage.heading2': 'hành trình thương mại',
  'contactPage.heroDesc': 'Đội ngũ chuyên gia sẵn sàng hỗ trợ. Vui lòng liên hệ qua biểu mẫu gửi tin nhắn bên dưới.',
  'contactPage.offices.heading': 'Văn phòng của chúng tôi',
  'contactPage.offices.seoul': 'Trụ sở Seoul',
  'contactPage.offices.hcmc': 'TP. Hồ Chí Minh',
  'contactPage.offices.hours': 'Giờ làm việc',
  'contactPage.offices.hoursMF': 'Thứ Hai – Thứ Sáu: 09:00 – 18:00 KST',
  'contactPage.offices.hoursSat': 'Thứ Bảy: 09:00 – 13:00 KST',
  'contactPage.offices.hoursNote': 'Đường dây khẩn cấp 24/7 cho lô hàng đang vận chuyển',
  'contactPage.form.heading': 'Gửi tin nhắn cho chúng tôi',
  'contactPage.form.sub': 'Điền biểu mẫu và chuyên gia sẽ phản hồi trong một ngày làm việc.',
  'contactPage.form.name': 'Họ và tên',
  'contactPage.form.email': 'Địa chỉ email',
  'contactPage.form.company': 'Công ty',
  'contactPage.form.service': 'Dịch vụ quan tâm',
  'contactPage.form.serviceSelect': 'Chọn dịch vụ',
  'contactPage.form.message': 'Tin nhắn',
  'contactPage.form.messagePlaceholder': 'Hãy cho chúng tôi biết về yêu cầu thương mại của bạn...',
  'contactPage.form.submit': 'Gửi tin nhắn',
  'contactPage.form.submitting': 'Đang gửi...',
  'contactPage.form.successTitle': 'Đã nhận tin nhắn',
  'contactPage.form.successDesc': 'Cảm ơn bạn đã liên hệ. Đội ngũ sẽ phản hồi trong một ngày làm việc.',
  'contactPage.form.error': 'Đã xảy ra lỗi. Vui lòng thử lại hoặc gửi email trực tiếp.',

  // Import Brands
  'importBrands.eyebrow': 'Thương hiệu nhập khẩu',
  'importBrands.heading1': 'Thương hiệu cao cấp Việt Nam',
  'importBrands.heading2': 'Nhập khẩu & Phân phối chính thức tại Hàn Quốc',
  'importBrands.subDesc': 'Những thương hiệu Việt Nam được MONARU tuyển chọn và phân phối độc quyền tại Hàn Quốc',
  'importBrands.badge': 'Đối tác nhập khẩu chính thức',
  'importBrands.established': 'Năm thành lập',
  'importBrands.aboutBrand': 'Giới thiệu thương hiệu',
  'importBrands.officialPartner': 'MONARU - Nhập khẩu & Phân phối chính thức tại Hàn Quốc',
  'importBrands.officialPartnerDesc': 'Phân phối toàn quốc Hàn Quốc và cung cấp B2B qua MONARU',
  'importBrands.productLine': 'Dòng sản phẩm',
  'importBrands.ctaInquiry': 'Hỏi về nhập khẩu',
  'importBrands.ctaCatalog': 'Yêu cầu danh mục',
  'importBrands.stat.origin': 'Xuất xứ',
  'importBrands.stat.exportCountries': 'Quốc gia xuất khẩu',
  'importBrands.stat.heritage': 'Lịch sử thương hiệu',
  'importBrands.stat.marketShare': 'Cà phê hòa tan Việt Nam',

  // Brands Preview
  'brands.eyebrow': 'Thương hiệu nhập · xuất khẩu',
  'brands.heading1': 'Thương hiệu đối tác MONARU',
  'brands.heading2': 'Thương hiệu nổi bật',
  'brands.inquiry': 'Hỏi về thương hiệu',
  'brands.import': 'Nhập khẩu',
  'brands.export': 'Xuất khẩu',
  'brands.inquireNow': 'Hỏi ngay',

  // Partners Page
  'partnersPage.eyebrow': 'Mạng lưới',
  'partnersPage.heading1': 'Đối tác chiến lược',
  'partnersPage.heading2': 'Kết nối hai quốc gia',
  'partnersPage.heroDesc': 'Từ cơ quan chính phủ, tập đoàn lớn đến doanh nghiệp vừa và nhỏ — mạng lưới tin cậy trải rộng Hàn Quốc và Việt Nam đang chờ kết nối với bạn.',
  'partnersPage.section.eyebrow': 'Brand Gateway',
  'partnersPage.section.heading': 'Đối tác hợp tác MONARU',
  'partnersPage.section.sub': 'Cùng nhau xây dựng thành công tại cả hai quốc gia',
  'partnersPage.kr.label': 'Đối tác Hàn Quốc',
  'partnersPage.vn.label': 'Đối tác Việt Nam',
  'partnersPage.cta.eyebrow': 'Tham gia mạng lưới',
  'partnersPage.cta.heading': 'Trở thành đối tác chiến lược',
  'partnersPage.cta.desc': 'Hơn 1.240 doanh nghiệp đang tận dụng hành lang thương mại Hàn Quốc-Việt Nam. Hãy phát triển cùng đại lý thương mại song phương đáng tin cậy nhất khu vực.',
  'partnersPage.cta.btn': 'Đăng ký hợp tác',

  // Gallery Page
  'galleryPage.eyebrow': 'Câu chuyện hình ảnh',
  'galleryPage.heading1': 'Thư viện ảnh',
  'galleryPage.heading2': 'Hàn Quốc · Việt Nam',
  'galleryPage.heroDesc': 'Hành trình hình ảnh qua các cảng, quan hệ đối tác, phái đoàn thương mại và các địa danh định nghĩa hành lang Hàn Quốc-Việt Nam.',
  'galleryPage.filter.all': 'Tất cả',
  'galleryPage.filter.korea': 'Hàn Quốc',
  'galleryPage.filter.vietnam': 'Việt Nam',
  'galleryPage.filter.events': 'Sự kiện',
  'galleryPage.allPhotos': 'Tất cả ảnh',

  // Contact Form Service Options
  'contactPage.form.service.koreanExport': 'Tư vấn xuất khẩu thương hiệu Hàn Quốc',
  'contactPage.form.service.vietnamDist': 'Tư vấn phân phối thương hiệu Việt Nam',

  // Trade Data Page
  'tradeDataPage.eyebrow': 'Trung tâm phân tích',
  'tradeDataPage.heading1': 'Luồng thương mại',
  'tradeDataPage.heading2': 'Bảng phân tích',
  'tradeDataPage.desc': 'Số liệu thương mại song phương Hàn Quốc-Việt Nam theo thời gian thực, phân tích ngành và dự báo xu hướng. Dữ liệu từ KITA, VCCI và cơ quan hải quan.',
  'tradeDataPage.monthly.title': 'Khối lượng thương mại hàng tháng (triệu USD)',
  'tradeDataPage.monthly.sub': 'Xuất khẩu song phương Hàn Quốc & Việt Nam — FY2024',
  'tradeDataPage.category.title': 'Thương mại theo danh mục (%)',
  'tradeDataPage.category.sub': 'Phân bổ ngành trong thương mại song phương',
  'tradeDataPage.distribution.title': 'Phân phối thương mại',
  'tradeDataPage.distribution.sub': 'Cơ cấu tổng thể theo ngành',
  'tradeDataPage.stat.totalVolume': 'Tổng khối lượng thương mại',
  'tradeDataPage.stat.activeCompanies': 'Doanh nghiệp đang hoạt động',
  'tradeDataPage.stat.shipments': 'Lô hàng đã xử lý',
  'tradeDataPage.stat.nations': 'Quốc gia đối tác',
  'tradeDataPage.korea.exports': 'Xuất khẩu Hàn Quốc',
  'tradeDataPage.vietnam.exports': 'Xuất khẩu Việt Nam',
  'tradeDataPage.korea.label': 'Hàn Quốc',
  'tradeDataPage.vietnam.label': 'Việt Nam',
  'tradeDataPage.yoy': 'So với năm trước',

  // Page Titles
  'page.title.home': 'MONARU | Cửa ngõ thương hiệu Hàn-Việt',
  'page.title.about': 'MONARU | Giới thiệu',
  'page.title.services': 'MONARU | Dịch vụ',
  'page.title.partners': 'MONARU | Đối tác',
  'page.title.tradeData': 'MONARU | Dữ liệu thương mại',
  'page.title.gallery': 'MONARU | Thư viện',
  'page.title.contact': 'MONARU | Liên hệ',
  'page.title.news': 'MONARU | Tin tức',

  // Nav - News
  'nav.news': 'Tin tức',

  // News Page
  'newsPage.eyebrow': 'Cập nhật mới nhất',
  'newsPage.heading1': 'MONARU',
  'newsPage.heading2': 'Tin tức & Góc nhìn',
  'newsPage.heroDesc': 'Cập nhật tin tức mới nhất, góc nhìn chuyên ngành và các hoạt động MONARU trong thương mại Hàn-Việt.',
  'newsPage.all': 'Tất cả',
  'newsPage.readMore': 'Xem thêm',
  'newsPage.empty': 'Chưa có bài đăng.',
  'newsPage.backToList': 'Quay lại danh sách',
  'newsPage.publishedAt': 'Đăng lúc',
  'newsPage.by': 'Tác giả',
  'newsPage.share': 'Chia sẻ',
  'newsPage.notFound': 'Không tìm thấy bài viết.',
};

export default translations;
